// extracted by mini-css-extract-plugin
export var container = "_2c-1";
export var editor = "_2c-2";
export var resizable = "_2c-3";
export var wrapper = "_2c-0";